import { useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { productKeys } from './keys';

import type { TypeGetOrderTypeInfoResponse } from '~/types/product.types';

/**
 * [상품관리] 오더유형 정보 조회 API
 */
export const fetchOrderTypeInfo = async (): Promise<TypeGetOrderTypeInfoResponse> => {
  const endpoint = '/api-lip/v1/order-type/info';
  const { data } = await axiosInstance.get<TypeGetOrderTypeInfoResponse>(endpoint);
  return data;
};

type UseGetOrderTypeInfoQueryOptions = {
  enabled?: boolean;
  showGlobalErrorToast?: boolean;
};

/**
 * [상품관리] 오더유형 정보 조회 Query Hook
 * @description 상품등록/수정 모달에서 오더유형 자동 매핑에 사용
 */
export const useGetOrderTypeInfoQuery = ({
  enabled = true,
  showGlobalErrorToast = true,
}: UseGetOrderTypeInfoQueryOptions = {}) => {
  return useQuery({
    queryKey: productKeys.orderTypeInfo(),
    queryFn: fetchOrderTypeInfo,
    staleTime: 1000 * 60 * 30,
    enabled,
    meta: { showGlobalErrorToast },
  });
};
